module.exports = __webpack_public_path__ + "img/calendar.08f491bf.svg";